import { useState } from "react";

function GalleryPhoto({ photo, index, chronicleId }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <figure className="min-w-0 border border-white/10 bg-white/[0.03]" data-testid={`chronicle-gallery-item-${chronicleId}-${index}`}>
      <img src={photo.url} alt={photo.caption || `Fotografía ${index + 1}`} onError={() => setFailed(true)} className="aspect-[4/3] w-full object-cover image-treatment" data-testid={`chronicle-gallery-photo-${chronicleId}-${index}`} />
      {photo.caption ? <figcaption className="px-3 py-2 text-xs leading-5 text-slate-400" data-testid={`chronicle-gallery-caption-${chronicleId}-${index}`}>{photo.caption}</figcaption> : null}
    </figure>
  );
}

export function ChronicleGallery({ chronicle }) {
  const photos = (chronicle.photos || []).filter((photo) => photo?.url);
  if (!photos.length) return null;
  return (
    <div className={`mt-6 grid gap-3 ${photos.length === 1 ? "max-w-md" : photos.length === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2"}`} data-testid={`chronicle-gallery-${chronicle.id}`}>
      {photos.map((photo, index) => <GalleryPhoto key={`${photo.url}-${index}`} photo={photo} index={index} chronicleId={chronicle.id} />)}
    </div>
  );
}
